// AUTO-GENERATED by scripts/gen-version.js — do not edit by hand.
export const APP_VERSION = "1.0.198";
export const BUILD_DATE = "2026-11-02";
